'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var Link = require('../../00.helper/Link/Link.js');
var classNames = _interopDefault(require('classnames/dedupe'));
var Icon = require('../Icon/Icon.js');
require('./_index.scss.js');

var CLASSNAME = 'varta-link-button-cta',
    cnIcon = "".concat(CLASSNAME, "__icon"),
    cnText = "".concat(CLASSNAME, "__text");
/**
 * 
 * @param {*} param0 
 * @returns 
 */

function ButtonCta(_ref) {
  var className = _ref.className,
      icon = _ref.icon,
      link = _ref.link,
      onClick = _ref.onClick,
      style = _ref.style,
      tagName = _ref.tagName,
      title = _ref.title;

  if (!tagName) {
    return /*#__PURE__*/React__default.createElement("span", {
      onClick: onClick
    }, /*#__PURE__*/React__default.createElement(Link, {
      link: link,
      className: classNames(className, CLASSNAME),
      style: style
    }, icon && /*#__PURE__*/React__default.createElement(Icon, {
      id: icon,
      size: "xs",
      className: cnIcon
    }), /*#__PURE__*/React__default.createElement("span", {
      className: cnText
    }, title)));
  }

  var Tag = tagName;
  return /*#__PURE__*/React__default.createElement(Tag, {
    className: classNames(className, CLASSNAME),
    style: style,
    href: link,
    onClick: onClick ? function (e) {
      e.preventDefault();
      onClick(e);
    } : null
  }, icon && /*#__PURE__*/React__default.createElement(Icon, {
    id: icon,
    size: "xs",
    className: cnIcon
  }), /*#__PURE__*/React__default.createElement("span", {
    className: cnText
  }, title));
}
ButtonCta.propTypes = {
  /** Additional class name */
  className: PropTypes.string,

  /** */
  icon: PropTypes.string,

  /** */
  link: PropTypes.string,

  /** */
  onClick: PropTypes.func,

  /** */
  style: PropTypes.object,

  /** */
  tagName: PropTypes.string,

  /** */
  title: PropTypes.string.isRequired
};

module.exports = ButtonCta;
